<template>
  <sweet-modal ref="addField" :title="$t('ct-add-field')" blocking hide-close-button width="600px">
    <div class="container-field-add">
      <button class="btn btn-primary" type="button" @click="openPopupField('text', 'text')">
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>
        {{ $t('ct-input-text') }}
      </button>
      <button class="btn btn-primary" type="button" @click="openPopupField('text', 'textarea')">
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>
        {{ $t('ct-input-textarea') }}
      </button>
      <button class="btn btn-primary" type="button" @click="openPopupField('text', 'password')">
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>
        {{ $t('ct-input-password') }}
      </button>
      <button class="btn btn-primary" type="button" @click="openPopupField('select', 'checkbox')">
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>
        {{ $t('ct-input-checkbox') }}
      </button>
      <button class="btn btn-primary" type="button" @click="openPopupField('select', 'radio')">
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>
        {{ $t('ct-input-radio') }}
      </button>
      <button class="btn btn-primary" type="button" @click="openPopupField('select', 'select')">
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>
        {{ $t('ct-input-select') }}
      </button>
      <button class="btn btn-primary" type="button" @click="openPopupField('text', 'date')">
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>
        {{ $t('ct-input-date') }}
      </button>
      <button class="btn btn-primary" type="button" @click="openPopupField('text', 'datetime')">
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="font-awesome-icon mr-2"/>
        {{ $t('ct-input-datetime') }}
      </button>
    </div>
    <button slot="button" class="btn btn-outline-light" @click.prevent="close">{{ $t('ct-cancel') }}</button>
  </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue';

export default {
  components: {
    SweetModal
  },
  data() {
    return {};
  },

  methods: {
    openPopupField(type, value) {
      this.$emit('openPopupField', type, value)
    },
    close() {
      this.$refs.addField.close();
      this.$emit('close', 'addField')
    },
    open() {
      this.$refs.addField.open();
    }
  },
  created() {

  }
};
</script>

<style lang="scss">
.container-field-add {
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 15px;

  margin-left: -15px;
  margin-right: -15px;

  .btn {
    font: normal normal 800 14px/16px Muli;
    text-transform: uppercase;

    height: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/ConfigModals/AddField.vue